import React from 'react';
import PropTypes from 'prop-types';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

import { useTheme } from 'contexts/ThemeContext';

import { Item } from 'components/Layout';

import { Text } from './Text';

export const WarningMessage = ({ title, children }) => {
  const { themeColors } = useTheme();
  const { amber, amberBg, amberBorder, amberDark } = themeColors.designSystem;

  return (
    <Item
      flex
      justify="flex-start"
      alignItems="flex-start"
      style={{
        gap: '9px',
        width: '100%',
        backgroundColor: amberBg,
        border: `1px solid ${amberBorder}`,
        borderRadius: '8px',
        padding: '10px 12px'
      }}
    >
      <ReportProblemOutlinedIcon
        style={{
          color: amber,
          fontSize: '18px',
          marginTop: '1px',
          flexShrink: 0
        }}
      />
      <Text fontSize="12px" color={amber} style={{ lineHeight: 1.5 }}>
        {title && (
          <Text component="span" bold color={amberDark}>
            {title}{' '}
          </Text>
        )}
        {children}
      </Text>
    </Item>
  );
};

WarningMessage.defaultProps = {
  title: null
};
WarningMessage.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default WarningMessage;
